import { jsx } from "panel";
import { selx } from "clsx";
import { nameToInitials } from "common/util/string";
import { TooltipEl } from "common/components/tooltip";
import emptyIconImage from "./empty-icon.svg";
import mpAvatarUrl from "./mp-avatar.svg";
import styles from "./index.module.styl";
const ImageIcon = ({
  src,
  iconSize,
  handleAvatarImageLoaded,
  elref,
  isAvatarImageLoaded = true,
  isStaffIcon = false
}) => /* @__PURE__ */ jsx("div", { sel: selx(styles.imageIcon, styles.colorAvatar), class: {
  [styles.loading]: !isAvatarImageLoaded
}, "data-sentry-component": "ImageIcon", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("img", { sel: selx(styles.img), attrs: {
  elref,
  align: `middle`,
  src,
  loading: `lazy`
}, style: {
  height: isStaffIcon ? `${iconSize * (2 / 3)}px` : `${iconSize}px`,
  width: isStaffIcon ? `${iconSize * (2 / 3)}px` : `${iconSize}px`,
  ...isStaffIcon ? {
    margin: `${iconSize / 6}px`
  } : {}
}, on: {
  load: handleAvatarImageLoaded
} }));
const InitialsIcon = ({
  name,
  backgroundClassName
}) => /* @__PURE__ */ jsx("div", { class: {
  [backgroundClassName]: true,
  [styles.initialsIcon]: true
}, attrs: {
  elref: `initialsIcon`
}, "data-sentry-component": "InitialsIcon", "data-sentry-source-file": "template.tsx" }, nameToInitials(name));
const Placeholder = ({
  userIcon,
  iconSize,
  name
}) => {
  if (name) {
    return /* @__PURE__ */ jsx(InitialsIcon, { name, backgroundClassName: userIcon.helpers.getBackgroundColorClass() });
  }
  return /* @__PURE__ */ jsx(ImageIcon, { src: emptyIconImage, iconSize, isAvatarImageLoaded: true, elref: "defaultImg", "data-sentry-element": "ImageIcon", "data-sentry-component": "Placeholder", "data-sentry-source-file": "template.tsx" });
};
const Avatar = ({
  userIcon,
  iconSize,
  name
}) => {
  const avatarUrl = userIcon.helpers.getAvatarUrl();
  const {
    isAvatarImageLoaded
  } = userIcon.state;
  if (avatarUrl) {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ImageIcon, { src: avatarUrl, iconSize, isAvatarImageLoaded, elref: "userImg", handleAvatarImageLoaded: userIcon.helpers.handleAvatarImageLoaded, isStaffIcon: userIcon.shouldShowStaffAvatar() }), isAvatarImageLoaded ? null : /* @__PURE__ */ jsx(Placeholder, { userIcon, iconSize, name }));
  }
  return /* @__PURE__ */ jsx(Placeholder, { userIcon, iconSize, name, "data-sentry-element": "Placeholder", "data-sentry-component": "Avatar", "data-sentry-source-file": "template.tsx" });
};
export function Template() {
  const {
    iconSize,
    fontSize
  } = this.helpers.getIconProperties();
  const name = this.helpers.getDisplayName();
  const labelPrefix = this.attr(`label-prefix`);
  const labelSuffix = this.attr(`label-suffix`);
  const label = `${labelPrefix} ${name} ${labelSuffix}`.trim();
  return /* @__PURE__ */ jsx("div", { class: {
    [styles.clickable]: this.helpers.shouldOpenSidebar(),
    [styles.container]: true
  }, attrs: {
    tabindex: 0
  }, on: {
    click: this.helpers.handleIconClick,
    keypress: this.helpers.handleIconClick
  }, "data-sentry-component": "Template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: selx(styles.avatarContainer), style: {
    "font-size": `${fontSize}px`,
    height: `${iconSize}px`,
    "line-height": `${iconSize}px`,
    width: `${iconSize}px`,
    "min-width": `${iconSize}px`
  }, class: {
    [styles.isStaffMemberImage]: !!this.attr(`staff-member-avatar-uuid`),
    [styles.offline]: this.attr(`is-offline`)
  } }, /* @__PURE__ */ jsx(Avatar, { userIcon: this, iconSize, name, "data-sentry-element": "Avatar", "data-sentry-source-file": "template.tsx" }), this.attr(`staff-member-avatar-uuid`) && /* @__PURE__ */ jsx("img", { sel: selx(styles.staffMemberImageOverlay, styles.img), attrs: {
    src: mpAvatarUrl
  } })), !this.attr(`disable-tooltip`) && this.attr(`name`) && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: this.attr(`tooltip-placement`),
    offset: 12
  }, sel: selx(styles.mpTooltip) }, labelPrefix && /* @__PURE__ */ jsx("div", { sel: selx(styles.tooltipSubtitle) }, labelPrefix), /* @__PURE__ */ jsx("div", { sel: selx(styles.tooltipText) }, name), labelSuffix && /* @__PURE__ */ jsx("div", { sel: selx(styles.tooltipSubtitle) }, labelSuffix)), this.attr(`include-label`) ? /* @__PURE__ */ jsx("div", { sel: selx(styles.label), attrs: {
    elref: `label`
  }, style: {
    "line-height": `${iconSize}px`
  } }, label) : null);
}
